import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const schemaListRoute: RouteConfig = {
  path: 'schema',
  name: 'schemaList',
  component: () => import(/* webpackChunkName: "SchemaList" */ '@/views/mainRoute/schema/List.vue'),
  meta: {
    breadcrumb: {
      title: 'Schemy',
      name: 'schemaList'
    },
    config: {
      title: 'Schemy',
      name: 'schemaList',
      icon: 'fa-file-alt',
      permissions: ['SCHEMA.UPDATE'],
      group: 'Konfiguracja wzorów'
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('schema/list', { count: -1, search: to.query.search })
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.SCHEMA_CANNOT_LIST }));
  }
};
